<template>
  <v-container class="pt-6">
    <v-card class="elevation-12 mb-6">
      <v-card-title class="px-9 pt-7">
        Plánované bezproudí
      </v-card-title>
      <v-card-text>
        <v-row class="planned-outage-header py-3">
          <v-col class="px-8 d-flex align-center">
            <template v-if="plannedOutage.xlsxLink || plannedOutage.jsonLink">
              <v-col class="px-8 d-flex align-center">
                <span>
                  <span class="request-value">
                    Aktuálně plánované bezproudí platí vždy pro následujících 15 dní.
                  </span>
                  <br>
                  <span class="request-label">
                    EAN Vašeho zákazníka dotčeného bezproudím, předpokládaný začátek a konec ke
                    stažení:
                  </span>
                </span>
              </v-col>
              <div class="px-8 d-flex align-center align-items-end ">
                <v-btn
                  v-if="plannedOutage.xlsxLink"
                  depressed
                  :to="`${baseUrl}${plannedOutage.xlsxLink}`"
                  @click.prevent="fileDownload($event, plannedOutage, 'XLSX')"
                  target="_blank"
                  color="primary"
                  height="40px"
                >
                  <v-icon color="white" small class="mt-n1 mr-1">mdi-arrow-collapse-down</v-icon>
                  xlsx
                </v-btn>

                <v-btn
                  v-if="plannedOutage.jsonLink"
                  depressed
                  :to="`${baseUrl}${plannedOutage.jsonLink}`"
                  @click.prevent="fileDownload($event, plannedOutage, 'JSON')"
                  target="_blank"
                  color="primary"
                  height="40px"
                  class="ml-1"
                >
                  <v-icon color="white" small class="mt-n1 mr-1">mdi-arrow-collapse-down</v-icon>
                  json
                </v-btn>
              </div>
            </template>
            <template v-else>
              <span class="font-weight-bold">
                {{ plannedOutage.errorMessage }}
              </span>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="elevation-12 mb-6">
      <v-card-text>
        <TablePlannedOutage
          v-model="plannedOutage"
          @onChangeOptions="loadPlannedOutage"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import TablePlannedOutage from '@/components/tables/TablePlannedOutage.vue';
import { setFilters } from '@/components/mixins/setFilters';
import { downloadFile } from '@/components/mixins/downloadFile';
import requestUrlFunction from '@/utils/requestUrl';

export default {
  name: 'PlannedOutage',
  mixins: [setFilters, downloadFile],
  components: {
    TablePlannedOutage,
  },
  data() {
    return {
      dialog: {
        content: '',
        show: false,
        data: {},
      },
      plannedOutage: {
        selected: [],
        items: [],
        options: {
          page: 1,
          itemsPerPage: this.$store.state.settings.tables.plannedOutageList.itemsPerPage,
          sortBy: ['day'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
        xlsxLink: '',
        jsonLink: '',
        day: '',
        errorMessage: '',
      },
      cancel: null,
      interval: null,
      baseUrl: process.env.VUE_APP_BACKEND,
    };
  },
  methods: {
    ...mapActions({
      getPlannedOutageLinks: 'installations/getPlannedOutageLinks',
    }),
    loadPlannedOutage() {
      this.plannedOutage.loading = true;
      const searchParams = {};
      if (this.cancel) {
        this.cancel();
        this.cancel = null;
      }
      searchParams.cancelHandler = (cancel) => {
        this.cancel = cancel;
      };
      this.getPlannedOutageLinks(searchParams).then((response) => {
        this.plannedOutage.items = response.data.history;

        if (response.data.actual.errorMessage) {
          this.plannedOutage.errorMessage = 'V následujících 15 dnech neevidujeme žádnou plánovanou odstávku.';
        } else {
          this.plannedOutage.xlsxLink = response.data.actual.xlsxLink;
          this.plannedOutage.jsonLink = response.data.actual.jsonLink;
          this.plannedOutage.day = response.data.actual.day;
        }

        this.cancel = null;
      }).finally(() => {
        this.plannedOutage.loading = false;
      });
    },
    fileDownload(event, item, fileFormat) {
      const searchParams = {
        filterParams: {
          reportCreated: item.day,
          reportFileFormat: fileFormat,
        },
      };
      this.downloadFile(event, `installations/planned-outage/export/${requestUrlFunction(searchParams)}`);
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadPlannedOutage();
      },
    },
  },
  created() {
    this.loadPlannedOutage();
  },
};
</script>

<style lang="scss">
.planned-outage-header {
  background: #e7e9ef;
}

.v-card__text {
  .planned-outage-header {
    margin-left: -16px;
    margin-right: -16px;
  }
}
</style>
